import React from 'react';
import PropTypes from 'prop-types';
import { H2 } from '@sitebase/ui-kit';
import classNames from 'classnames';

import './pageTitle.scss';

const PageTitle = ({ pageTitle, mobile }) => {
    const pageTitleCss = classNames('page-title', {
        'page-title--mobile': mobile,
    });

    return (
        <span styleName={pageTitleCss}>
            <H2>{pageTitle}</H2>
        </span>
    );
};

export const pageTitlePropTypes = PropTypes.string;

PageTitle.propTypes = {
    pageTitle: pageTitlePropTypes,
    mobile: PropTypes.bool.isRequired,
};

export default PageTitle;
